defineDs('DanskeSpil/Domain/PlayTogether/Scripts/Templates/ViewCoupon/CouponHeader',
  [
    'Shared/Framework/Mithril/Scripts/Core/Mithril',
    'DanskeSpil/Domain/PlayTogether/Scripts/Helpers/Utils'
  ],
  function (m, Utils) {
    var gameLogoNames = {
      eurojackpot: 'icon-eurojackpot_logo_bg_yellow',
      lottosaturday: 'icon-lotto_logo_red',
      vikinglotto: 'icon-vikinglotto_logo_blue'
    };

    var iconsPath = '/Components/DanskeSpil/Domain/PlayTogether/Graphics/SpriteSheets/PlayTogetherIcons.svg#';
    const numberGamesIconsPath = '/Components/DanskeSpil/Domain/NumberGamePackage/Graphics/SpriteSheets/PackageCommonIcons.svg#';

    var CouponHeader = {
      controller: function (args) {
        if (args) {
          Object.assign(this, args.controller);
        }

        this.headerDictionary = this.rootDictionary.get.bind({ prefix: 'ViewCoupon/CouponHeader/' });
        this.totalSectionDictionary = this.rootDictionary.get.bind({ prefix: 'ViewCoupon/CouponTotalSection/' });

        this.isEjp = this.play.game.toLowerCase() === 'eurojackpot';
        this.drawWeeks = Utils.formatDrawWeeks(this.play);
        this.totalRowCount = Utils.countTotalRows(this.play) / this.play.numberOfDraws;
        this.subscriptionGroupGameId = this.play.subscriptionGroupGameId;
      },
      view: function (controller) {
        const overviewItem = (args) => {
          return m('.play-overview__item', [
            m('svg.play-overview__item-icon', [
              m('use', { href: `${iconsPath}${args.icon}` })
            ]),
            m('.play-overview__item-text', args.text),
            m('.play-overview__item-value', args.value)
          ]);
        };

        // View:
        return m('.play-together-coupon-header', [
          m('.play-together-coupon-header__row', [
            m('svg', { class: 'game-logo' }, [
              m('use', { href: `${numberGamesIconsPath}${gameLogoNames[controller.play.game.toLowerCase()]}` })
            ]),
            m('.game-play-description', [
              m('.game-play-description__item', controller.headerDictionary(`PlayTypes/${controller.play.playType}`)),
              m('.game-play-description__item', controller.headerDictionary(controller.subscriptionGroupGameId ? 'AsSubscription' : 'DrawWeeks', { WEEKS: controller.drawWeeks })),
              m('.game-play-description__item', controller.headerDictionary(`${controller.play.depositType}DepositType`))
            ])
          ]),
          // Play overview:
          m('.play-together-coupon-header__row', [
            m('.play-overview-title', controller.totalSectionDictionary('Title')),
            m('.play-overview', [
              // number of rows
              overviewItem({
                icon: 'card_with_rows_tilted',
                text: controller.totalSectionDictionary(controller.isEjp ? 'RowsPerDraw' : 'RowsPerWeek'),
                value: controller.totalRowCount
              }),
              // total amount
              overviewItem({
                icon: 'coins',
                text: controller.totalSectionDictionary('TotalDeposit'),
                value: Utils.formatCurrency(controller.play.totalStakeAmount)
              }),
              // number of weeks
              controller.subscriptionGroupGameId ? null : overviewItem({
                icon: 'coupon-calendar',
                text: controller.totalSectionDictionary(controller.isEjp ? 'Draws' : 'Weeks'),
                value: controller.play.numberOfDraws
              })
            ])
          ])
        ]);
      }
    };

    // Public functions:
    return CouponHeader;
  });
